import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["banner"];

  dismiss() {
    this.bannerTarget.classList.add("project-banner--closed");
  }
}
